import type { Nullable } from 'corgi-types';

import type {
  GraphqlNavigationItemProps,
  PrimaryNavigationItemProps,
} from 'common/types/NavigationItem';
import { CONTAINER_MAX_WIDTH, LOGO_MAX_WIDTH, PADDING_OFFSET, SEARCH_WIDTHS } from './constants';

export const getTopBarNavigation = (navigation: GraphqlNavigationItemProps) =>
  navigation.children?.reduce<PrimaryNavigationItemProps[]>((topNavigation, { name, href }) => {
    if (name) {
      topNavigation.push({ name, href });
    }

    return topNavigation;
  }, []);

export const getMenuWidths = () =>
  SEARCH_WIDTHS.slice(1).map(
    searchWidth =>
      `calc(min(100vw, ${CONTAINER_MAX_WIDTH}px) - ${Number(searchWidth) + LOGO_MAX_WIDTH + PADDING_OFFSET}px)`
  );

export const getScrollTop = (scrollable?: HTMLElement | Window) => {
  if (scrollable instanceof Window) {
    return scrollable.scrollY;
  }

  if (scrollable instanceof HTMLElement) {
    return scrollable.scrollTop;
  }

  return 0;
};

// This is a simplified version of the code from the react-waypoint library
// that helps to find the first scrollable ancestor of a DOM node
//
// https://github.com/brigade/react-waypoint/blob/6004756ad6b6699f358fc6008e29e242b2777379/src/waypoint.jsx#L134-L168
export const findScrollableAncestor = (node: Nullable<HTMLElement>) => {
  while (node && node.parentNode) {
    node = node.parentNode as HTMLElement;

    if (node === document.body) {
      return window;
    }

    const style = window.getComputedStyle(node);
    const overflow = style.getPropertyValue('overflow-y') || style.getPropertyValue('overflow');

    if (overflow === 'auto' || overflow === 'scroll') {
      return node;
    }
  }

  return window;
};
